//#region CONST _ON_HOLD_TYPES
export const _ON_HOLD_TYPES: Readonly<{ [onHoldKey: number]: string }> = {
  [1]: 'Invoices and/or Recurring Charges',
  [2]: 'Credit Notes',
  [4]: 'Goods Receiving',
  [8]: 'Returns',
  [16]: 'Purchase Orders',
  [32]: 'Sales Orders',
  [64]: 'Quotes',
  [128]: 'Job Cards',
  [256]: 'Point of Sale',
  [512]: 'Stock Transfers',
  [1024]: 'Stock Transfer Requests',
  [2048]: 'Bill of Quantities',
  [4096]: 'NA',
  [8192]: 'NA',
  [16384]: 'NA',
  [32768]: 'NA',
  [65536]: 'NA',
  [131072]: 'NA',
  [262144]: 'NA',
  [524288]: 'NA',
  [1048576]: 'NA',
  [2097152]: 'NA',
  [4194304]: 'Agent Transactions',
  [8388608]: 'NA',
  [16777216]: 'Supplier Return Orders',
  [33554432]: 'NA',
  [67108864]: 'NA',
  [134217728]: 'Lay byes',
  [268435456]: 'NA',
  [536870912]: 'NA',
  [1073741824]: 'NA',
};
//#endregion

//#region CONST _SUPPLIER_ON_HOLD_TYPES
export const _SUPPLIER_ON_HOLD_TYPES: Readonly<{ [onHoldKey: number]: string }> = {
  [4]: 'GRV',
  [8]: 'Returns',
  [16]: 'Purchase Orders',
  [4194304]: 'Agent Transact',
  [8388608]: 'Journals',
  [33554432]: 'Request for quote',
};

//#endregion

//#region INTERFACE IOnHoldCodeDecodeOptions
export interface IOnHoldCodeDecodeOptions {
  isSupplier?: boolean;
  returnCodes?: boolean;
}

//#endregion